/**
 * This component is responsible for displaying the featured players for a game.
 */
import React from "react";
import GamePlayerSpotlight from "./GamePlayerSpotlight";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Loading from "../core/Loading";

const renderPlayerSpotlight = (playerData) => {
  if (playerData !== undefined) {
    return (
      <GamePlayerSpotlight
        id={playerData.id}
        club={playerData.club}
        title={playerData.title}
        name={playerData.name}
        team_name={playerData.team_name}
        backup={playerData.team_img}
        desc={playerData.description}
        stat={playerData.value}
      />
    );
  }
  return null;
};

const processPreviewData = (jsonData, game_data) => {
  let processedData = {
    watch: [],
    vet: [],
    net: [],
    form: [],
  };

  try {
    processedData.watch =
      jsonData.featured_players.watch[
        Math.floor(Math.random() * jsonData.featured_players.watch.length)
      ];
    processedData.vet =
      jsonData.featured_players.vet[
        Math.floor(Math.random() * jsonData.featured_players.vet.length)
      ];
    processedData.net =
      jsonData.featured_players.net[
        Math.floor(Math.random() * jsonData.featured_players.net.length)
      ];
    processedData.form =
      jsonData.featured_players.form[
        Math.floor(Math.random() * jsonData.featured_players.form.length)
      ];

    // DEBUG TO TEST IF ALL FEATURES ARE RUNNING
    // processedData.watch = jsonData.featured_players.watch;
    // processedData.vet = jsonData.featured_players.vet;
    // processedData.net = jsonData.featured_players.net;
    // processedData.form = jsonData.featured_players.form;
  } catch (e) {
    console.error(e);
  }

  return processedData;
};

const GameFeaturedPlayers = (game_data) => {
  const { gameId } = useParams();

  const { isLoading, error, data } = useQuery({
    staleTime: 3600000,
    queryKey: ["game", gameId, "featured"],
    queryFn: () =>
      fetch(`${process.env.REACT_APP_BUIHA_API_URL}/game/${gameId}/featured/`)
        .then((res) => res.json())
        .then((json) => {
          return processPreviewData(json, game_data);
        }),
  });

  if (isLoading)
    return (
      <Loading />
    );

  if (error) return "An error has occurred: " + error.message;

  return (
    <div className="flex flex-wrap xs:flex-row w-full xs:mt-4 mt-2 pb-2 justify-center items-center">
    {renderPlayerSpotlight(data.watch)}
    {renderPlayerSpotlight(data.vet)}
    {renderPlayerSpotlight(data.net)}
    {renderPlayerSpotlight(data.form)}

    {(!data.watch && !data.vet && !data.net && !data.form) && (
      <p className="text-center w-full rounded py-2 dark:bg-dark-4 bg-light-2">Preview not available</p>
    )}
  </div>
  );
};
export default GameFeaturedPlayers;
